import { get } from './fetch'

export const userRank = () => {
  return get(`stats/user-rank`, true)
}
